/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getGynicHistories } from 'app/entities/gynic-history/gynic-history.reducer';
import { getEntities as getObstetricEvents } from 'app/entities/obstetric-event/obstetric-event.reducer';
import { PhysicalActivity } from 'app/shared/model/enumerations/physical-activity.model';
import { Habbits } from 'app/shared/model/enumerations/habbits.model';
import { NutritionType } from 'app/shared/model/enumerations/nutrition-type.model';
import { AssessmentType } from 'app/shared/model/enumerations/assessment-type.model';
import { TriageCode } from 'app/shared/model/enumerations/triage-code.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { SedationScore } from 'app/shared/model/enumerations/sedation-score.model';
import { createEntity, getEntity, reset, updateEntity } from './pre-assessment.reducer';

export const PreAssessmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const admissions = useAppSelector(state => state.admission.entities);
  const gynicHistories = useAppSelector(state => state.gynicHistory.entities);
  const obstetricEvents = useAppSelector(state => state.obstetricEvent.entities);
  const preAssessmentEntity = useAppSelector(state => state.preAssessment.entity);
  const loading = useAppSelector(state => state.preAssessment.loading);
  const updating = useAppSelector(state => state.preAssessment.updating);
  const updateSuccess = useAppSelector(state => state.preAssessment.updateSuccess);
  const physicalActivityValues = Object.keys(PhysicalActivity);
  const habbitsValues = Object.keys(Habbits);
  const nutritionTypeValues = Object.keys(NutritionType);
  const assessmentTypeValues = Object.keys(AssessmentType);
  const triageCodeValues = Object.keys(TriageCode);
  const addedByTypeValues = Object.keys(AddedByType);
  const sedationScoreValues = Object.keys(SedationScore);

  const handleClose = () => {
    navigate(`/pre-assessment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAdmissions({}));
    dispatch(getGynicHistories({}));
    dispatch(getObstetricEvents({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...preAssessmentEntity,
      ...values,
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      gynicHistory: gynicHistories.find(it => it.id.toString() === values.gynicHistory?.toString()),
      obstetricEvent: obstetricEvents.find(it => it.id.toString() === values.obstetricEvent?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          physicalActivity: 'SEDENTARY',
          habbits: 'NONE',
          nutritionType: 'VEG',
          assessmentType: 'ASSESSMENT',
          code: 'RED',
          addedByType: 'ACCOUNTANT',
          modifiedByType: 'ACCOUNTANT',
          consciousness: 'AWAKE',
          ...preAssessmentEntity,
          admission: preAssessmentEntity?.admission?.id,
          gynicHistory: preAssessmentEntity?.gynicHistory?.id,
          obstetricEvent: preAssessmentEntity?.obstetricEvent?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.preAssessment.home.createOrEditLabel" data-cy="PreAssessmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.preAssessment.home.createOrEditLabel">Create or edit a PreAssessment</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pre-assessment-id"
                  label={translate('tinyMedicRestApp.preAssessment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.microSec')}
                id="pre-assessment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.timestampentry')}
                id="pre-assessment-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.lastupdated')}
                id="pre-assessment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.cursor')}
                id="pre-assessment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.active')}
                id="pre-assessment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.physicalActivity')}
                id="pre-assessment-physicalActivity"
                name="physicalActivity"
                data-cy="physicalActivity"
                type="select"
              >
                {physicalActivityValues.map(physicalActivity => (
                  <option value={physicalActivity} key={physicalActivity}>
                    {translate(`tinyMedicRestApp.PhysicalActivity.${physicalActivity}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.habbits')}
                id="pre-assessment-habbits"
                name="habbits"
                data-cy="habbits"
                type="select"
              >
                {habbitsValues.map(habbits => (
                  <option value={habbits} key={habbits}>
                    {translate(`tinyMedicRestApp.Habbits.${habbits}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.habbitDetails')}
                id="pre-assessment-habbitDetails"
                name="habbitDetails"
                data-cy="habbitDetails"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.sexualAbuse')}
                id="pre-assessment-sexualAbuse"
                name="sexualAbuse"
                data-cy="sexualAbuse"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.sexualAbuseDetails')}
                id="pre-assessment-sexualAbuseDetails"
                name="sexualAbuseDetails"
                data-cy="sexualAbuseDetails"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.exposureToPets')}
                id="pre-assessment-exposureToPets"
                name="exposureToPets"
                data-cy="exposureToPets"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.exposureToPetsDetails')}
                id="pre-assessment-exposureToPetsDetails"
                name="exposureToPetsDetails"
                data-cy="exposureToPetsDetails"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.nutritionType')}
                id="pre-assessment-nutritionType"
                name="nutritionType"
                data-cy="nutritionType"
                type="select"
              >
                {nutritionTypeValues.map(nutritionType => (
                  <option value={nutritionType} key={nutritionType}>
                    {translate(`tinyMedicRestApp.NutritionType.${nutritionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.pastSurgicalHistory')}
                id="pre-assessment-pastSurgicalHistory"
                name="pastSurgicalHistory"
                data-cy="pastSurgicalHistory"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.systemicExamination')}
                id="pre-assessment-systemicExamination"
                name="systemicExamination"
                data-cy="systemicExamination"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.cardiovascularSystem')}
                id="pre-assessment-cardiovascularSystem"
                name="cardiovascularSystem"
                data-cy="cardiovascularSystem"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.respiratorySystem')}
                id="pre-assessment-respiratorySystem"
                name="respiratorySystem"
                data-cy="respiratorySystem"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.centralNervousSystem')}
                id="pre-assessment-centralNervousSystem"
                name="centralNervousSystem"
                data-cy="centralNervousSystem"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.abdomen')}
                id="pre-assessment-abdomen"
                name="abdomen"
                data-cy="abdomen"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.genitalNRectum')}
                id="pre-assessment-genitalNRectum"
                name="genitalNRectum"
                data-cy="genitalNRectum"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.skin')}
                id="pre-assessment-skin"
                name="skin"
                data-cy="skin"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.pulse')}
                id="pre-assessment-pulse"
                name="pulse"
                data-cy="pulse"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.extremities')}
                id="pre-assessment-extremities"
                name="extremities"
                data-cy="extremities"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.back')}
                id="pre-assessment-back"
                name="back"
                data-cy="back"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.uncommonSymptoms')}
                id="pre-assessment-uncommonSymptoms"
                name="uncommonSymptoms"
                data-cy="uncommonSymptoms"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.weightChanges')}
                id="pre-assessment-weightChanges"
                name="weightChanges"
                data-cy="weightChanges"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.fever')}
                id="pre-assessment-fever"
                name="fever"
                data-cy="fever"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.ageOfLastChild')}
                id="pre-assessment-ageOfLastChild"
                name="ageOfLastChild"
                data-cy="ageOfLastChild"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.obstetricPara')}
                id="pre-assessment-obstetricPara"
                name="obstetricPara"
                data-cy="obstetricPara"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.obstetricGravida')}
                id="pre-assessment-obstetricGravida"
                name="obstetricGravida"
                data-cy="obstetricGravida"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.abortions')}
                id="pre-assessment-abortions"
                name="abortions"
                data-cy="abortions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.sourceOfHistory')}
                id="pre-assessment-sourceOfHistory"
                name="sourceOfHistory"
                data-cy="sourceOfHistory"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.chiefComplaints')}
                id="pre-assessment-chiefComplaints"
                name="chiefComplaints"
                data-cy="chiefComplaints"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.historyOfPresentIllness')}
                id="pre-assessment-historyOfPresentIllness"
                name="historyOfPresentIllness"
                data-cy="historyOfPresentIllness"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.medicalHistory')}
                id="pre-assessment-medicalHistory"
                name="medicalHistory"
                data-cy="medicalHistory"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.familyHistory')}
                id="pre-assessment-familyHistory"
                name="familyHistory"
                data-cy="familyHistory"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.admissiondiagnosis')}
                id="pre-assessment-admissiondiagnosis"
                name="admissiondiagnosis"
                data-cy="admissiondiagnosis"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.historyOfImmunization')}
                id="pre-assessment-historyOfImmunization"
                name="historyOfImmunization"
                data-cy="historyOfImmunization"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.medicineReviewed')}
                id="pre-assessment-medicineReviewed"
                name="medicineReviewed"
                data-cy="medicineReviewed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.assessmentType')}
                id="pre-assessment-assessmentType"
                name="assessmentType"
                data-cy="assessmentType"
                type="select"
              >
                {assessmentTypeValues.map(assessmentType => (
                  <option value={assessmentType} key={assessmentType}>
                    {translate(`tinyMedicRestApp.AssessmentType.${assessmentType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.code')}
                id="pre-assessment-code"
                name="code"
                data-cy="code"
                type="select"
              >
                {triageCodeValues.map(triageCode => (
                  <option value={triageCode} key={triageCode}>
                    {translate(`tinyMedicRestApp.TriageCode.${triageCode}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.addedById')}
                id="pre-assessment-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.modifiedById')}
                id="pre-assessment-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.addedByType')}
                id="pre-assessment-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.modifiedByType')}
                id="pre-assessment-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preAssessment.consciousness')}
                id="pre-assessment-consciousness"
                name="consciousness"
                data-cy="consciousness"
                type="select"
              >
                {sedationScoreValues.map(sedationScore => (
                  <option value={sedationScore} key={sedationScore}>
                    {translate(`tinyMedicRestApp.SedationScore.${sedationScore}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="pre-assessment-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.preAssessment.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pre-assessment-gynicHistory"
                name="gynicHistory"
                data-cy="gynicHistory"
                label={translate('tinyMedicRestApp.preAssessment.gynicHistory')}
                type="select"
              >
                <option value="" key="0" />
                {gynicHistories
                  ? gynicHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pre-assessment-obstetricEvent"
                name="obstetricEvent"
                data-cy="obstetricEvent"
                label={translate('tinyMedicRestApp.preAssessment.obstetricEvent')}
                type="select"
              >
                <option value="" key="0" />
                {obstetricEvents
                  ? obstetricEvents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pre-assessment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PreAssessmentUpdate;
